module.exports = __webpack_public_path__ + "img/save.384d45e4.svg";